// T014 — Summary cards for the wallet detail page.
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";

import { formatEur } from "../../../utils/eur";
import type { WalletState } from "../../../types/wallet";

interface WalletSummaryCardsProps {
  wallet: WalletState;
}

const SummaryCard = ({ label, value }: { label: string; value: string }) => (
  <div className="col-12 sm:col-6 lg:col-3">
    <Card className="h-full">
      <div className="text-color-secondary text-sm mb-2">{label}</div>
      <div className="text-2xl font-bold">{value}</div>
    </Card>
  </div>
);

const WalletSummaryCards = ({ wallet }: WalletSummaryCardsProps) => {
  return (
    <div>
      <div className="grid">
        <SummaryCard label="Spendable balance" value={formatEur(wallet.spendable_balance)} />
        <SummaryCard label="Lifetime earned" value={formatEur(wallet.lifetime_earned)} />
        <SummaryCard label="Lifetime spent" value={formatEur(wallet.lifetime_spent)} />
        <SummaryCard label="Lifetime expired" value={formatEur(wallet.lifetime_expired)} />
      </div>
      <div className="mt-2 flex align-items-center gap-2 text-sm text-color-secondary">
        <span>Wallet auto-spend:</span>
        <Tag
          value={wallet.wallet_toggle_on ? "ON" : "OFF"}
          severity={wallet.wallet_toggle_on ? "success" : undefined}
        />
        <span className="text-xs">(read-only here — owner controls this in the Hub)</span>
      </div>
    </div>
  );
};

export default WalletSummaryCards;
